<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">{{module?.name || routeSegment}}</li>
  <li class="breadcrumb-item active">Evaluación</li>
</ol>

<h1 class="page-header"><i class="fas fa-clipboard-check"></i> {{module?.name || routeSegment}}<small> Evaluación</small></h1>

<div class="scrollable">
  @if(loading){
  <panel [noButton]="true"><div class="text-center py-4"><span class="spinner-border spinner-border-sm me-2"></span>Cargando evaluación...</div></panel>
  } @else {
  <div class="eval-top-bar">
    <span class="eval-top-item"><i class="fas fa-file-alt me-1"></i> {{period?.entity?.name || 'Iglesia Adventista del Séptimo día'}}</span>
    <span class="eval-top-item">
      <i class="fas fa-calendar me-1"></i> Periodo:
      <input type="month" class="form-control form-control-sm" style="display:inline-block; width:150px; vertical-align:middle;" [(ngModel)]="selectedMonth" [max]="maxMonth" (ngModelChange)="onMonthChange()">
    </span>
    <span class="eval-top-item"><i class="fas fa-list me-1"></i> Puntaje: <span class="badge ms-1" [style.background]="scoreColor()" style="font-size:11px; color:#fff">{{period?.score ?? 0}}%@if(scoreLabel()){ - {{scoreLabel()}} }</span>@if(period?.penaltyPercent > 0){<span class="badge bg-warning text-dark ms-1" style="font-size:11px" title="Penalización aplicada por el auditor">-{{period.penaltyPercent}}%</span>}</span>
    <span class="eval-top-item"><i class="fas fa-user me-1"></i> Auditor: {{period?.auditor?.displayName || 'UCh - Daphne Cuellar'}}</span>
    <span class="eval-top-item"><i class="fas fa-hourglass-half me-1"></i> Límite: {{period?.expiration ? (period.expiration | date:'dd-MM-yyyy') : '—'}}</span>
  </div>

  @if(!period && !noPeriodForMonth){
  <panel [noButton]="true"><div class="text-center text-muted py-4">No hay periodo abierto para este módulo.</div></panel>
  } @else if(noPeriodForMonth){
  <div class="alert alert-info mt-3"><i class="fas fa-info-circle me-1"></i>Aún no se crea el periodo seleccionado ({{selectedMonth}}) — contacte al administrador para abrirlo.</div>
  } @else {
  @if(isLocked()){
  <div class="alert alert-warning mt-3 mb-0"><i class="fas fa-lock me-1"></i>Esta evaluación está bloqueada. Solo un administrador puede reabrir el periodo desde <b>Periodos</b>.</div>
  }
  @if(missingGoalIds.size > 0){
  <div class="alert alert-warning mt-3 mb-0"><i class="fas fa-triangle-exclamation me-1"></i>{{missingGoalIds.size}} pregunta(s) sin meta anual definida — contacte al administrador en <b>Metas Personales</b>.</div>
  }
  @if(canReview()){
  <div class="alert alert-info mt-3 mb-0">
    <div class="d-flex flex-wrap align-items-center gap-2">
      <span><i class="fas fa-eye me-1"></i>Revisión del auditor — define si el puntaje ({{period?.score ?? 0}}%) corresponde:</span>
      <select class="form-select form-select-sm d-inline-block" style="width:auto" [(ngModel)]="reviewEntryMode">
        <option value="percent">Penalización %</option>
        <option value="raw">Puntaje final</option>
      </select>
      @if(reviewEntryMode === 'percent'){
      <label class="mb-0">Descuento <input type="number" class="form-control form-control-sm d-inline-block" style="width:80px" [(ngModel)]="reviewInput" min="0" max="100"></label>
      } @else {
      <label class="mb-0">Puntaje <input type="number" class="form-control form-control-sm d-inline-block" style="width:80px" [(ngModel)]="reviewInput" min="0" [max]="baseScore()"></label>
      }
      <span class="badge bg-primary">Final: {{reviewFinal()}}% (penalización {{reviewPenalty()}}%)</span>
      @if(rawTooHigh()){
      <span class="text-danger small">No puede superar el puntaje calculado ({{baseScore()}}%).</span>
      } @else {
      <button class="btn btn-sm btn-success" (click)="approveReview()"><i class="fas fa-check me-1"></i>Aprobar</button>
      }
      <button class="btn btn-sm btn-danger" (click)="rejectReview()"><i class="fas fa-rotate-left me-1"></i>Rechazar y reabrir</button>
    </div>
  </div>
  }

  <div class="mt-3">
    @for(cat of evaluation; track cat.category.id; let idx = $index){
    <app-evaluation-category [categoryData]="cat" [index]="idx" [locked]="isLocked()" [reviewMode]="canReview()" [signed]="isSigned()" [missingIds]="missingGoalIds" [completedIds]="completedGoalIds" (changed)="onAnswerChanged()"></app-evaluation-category>
    } @empty {
    <panel [noButton]="true"><div class="text-center text-muted py-3">Sin categorías configuradas para este periodo.</div></panel>
    }
  </div>

  @if(!reviewMode){
  <div class="d-flex justify-content-end mt-3 p-3 bg-white border rounded">
    <button class="btn btn-primary" [disabled]="isLocked()" (click)="finish()"><i class="fas fa-check-circle me-1"></i> Completar</button>
  </div>
  }
  }
  }
</div>
